var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceSquibLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M22.2,8.4c5.6,0,10.1,4.3,10.1,9.6s-4.5,9.6-10.1,9.6S12.1,23.3,12.1,18S16.6,8.4,22.2,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M40.4,10.8c2.6,0,4.8,2,4.8,4.6c0,2.5-2.1,4.6-4.8,4.6c-2.6,0-4.8-2-4.8-4.6 C35.6,12.9,37.7,10.8,40.4,10.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "black",
    points: "45.7,24.2 53.2,20.2 53.2,16.8 44.3,21.9 45.3,22.8 45.7,24.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M42.9,28.3l-7.2,11.5l-3.8-10.3l3.6-5.7c0.8-1.3,2.2-2,3.8-2c2.4,0,4.4,1.9,4.4,4.2 C43.6,26.8,43.4,27.6,42.9,28.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    points: "27.1,31.9 33.5,49.2 36.9,49.2 29.7,30.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M11.3,48c-0.6,0.7-1.4,1.1-2.4,1.1c-1.6,0-2.9-1.3-2.9-2.8c0-0.6,0.2-1.2,0.6-1.6l0,0l9.3-12 c0.7-0.8,1.7-1.3,2.8-1.3c0.1,0,0.2,0,0.3,0v-0.1l1.9,0.2l1.7,0.5l2.6,1l3.1,7.9l-7.7-2.4h-1.4L18,39.1L11.3,48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M29.5,28.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSquibLight);
export default __webpack_public_path__ + "static/media/device-squib-light.99cfb2953665ce09e7a8ae172b25df3e.svg";
export { ForwardRef as ReactComponent };